import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Segment } from "../types";

const useFirebaseSegments = () => {
  const uid = useFakedUID();
  return useFirebaseData<FirebaseRecord<Segment>>(uid ? `/userdata/${uid}/segments` : null);
};

export default useFirebaseSegments;
